import React from 'react';
import styled from 'styled-components';
import AlertMessageHolder from '@/containers/AlertMessageHolder';
import FlashMessageHolder from '@/containers/FlashMessageHolder';
import Modal from '@/containers/Modal';
import { PublicDatasetsTopPanel } from '@/features/publicDatasets/publicdatasets/PublicDatasetsTopPanel';
import { PublicDatasetQueryBuilder } from '@/containers/PublicDatasetQueryBuilder';
import { useTrackDatasourceId } from '@/hooks';
import styles from './PublicDatasetsAppPage.module.scss';

const Container = styled.div`
  display: flex;
  height: calc(100vh - 74px);

  [data-quickfix-remove-on-refactoring] {
    flex-grow: 1;
    overflow: auto;
    padding-left: 16px;
  }

  [data-quickfix-2-remove-on-refactoring] {
    padding: 0 20px 0 0;
  }
`;

const PublicDatasetsAppPage: React.FC = () => {
  useTrackDatasourceId();

  return (
    <div>
      <FlashMessageHolder />
      <AlertMessageHolder />
      <Modal />
      <div className={styles.main}>
        <div className={styles.pageContainer}>
          <PublicDatasetsTopPanel />
          <Container>
            <PublicDatasetQueryBuilder />
          </Container>
        </div>
      </div>
    </div>
  );
};

export default PublicDatasetsAppPage;
